<template>
  <div class="repository-warp">
    <div class="repository-content">
      <div class="search-warp">
        <el-date-picker v-model="search.date" size="small" type="daterange" value-format="yyyy/MM/dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-model="search.status" size="small" style="width:160px;margin-left:14px" filterable placeholder="计划状态">
          <el-option label="全部状态" :value="-1"></el-option>
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" size="small" style="margin-left:14px" @click="getData(1)">查询</el-button>
      </div>
      <div class="table-warp">
        <nk-table :columns="columns" :data="tableData" :page="page" :showPage="true" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
          <el-table-column label="操作" :align="'center'" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="showInfo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </nk-table>
      </div>
    </div>

    <el-drawer title="详情" :visible.sync="drawer" direction="rtl">
      <div class="drawer-main" v-if="info">
        <div class="drawer-cent">
          <div class="title">基本信息</div>
          <div>
            <div class="detailbox">
              <span class="label">合同名称</span><span>{{ info.contractName }}</span>
            </div>
            <div class="detailbox">
              <span class="label">合同编号</span><span>{{ info.contractId }}</span>
            </div>
            <div class="detailbox">
              <span class="label">项目名称</span><span>{{ info.projectName }}</span>
            </div>
            <div class="detailbox">
              <span class="label">项目编号</span><span>{{ info.projectNumber }}</span>
            </div>
            <div class="detailbox">
              <span class="label">项目备注</span><span>{{ info.projectRemark }}</span>
            </div>
          </div>
          <div class="title" style="margin-top:10px">服务内容</div>
          <div>
            <div class="detailbox">
              <span class="label">区域</span><span>{{ info.regionName }}</span>
            </div>
            <div class="detailbox">
              <span class="label">备注</span><span>{{ info.regionRemark }}</span>
            </div>
            <div class="detailbox">
              <div class="label">设备列表</div>
              <div>
                <p v-for="(item,index) in info.scopes" :key="index">{{ item.measureName }}</p>
              </div>
            </div>

          </div>
          <div class="title" style="margin-top:10px">规格内容</div>
          <div>
            <div class="detailbox">
              <span class="label">类型</span><span>{{getTask(info.specificationType) }}</span>
            </div>
            <template v-if="info.specificationConfig">
              <div class="detailbox">
                <span class="label">周期</span><span>{{ getCycle(info.specificationConfig.cycle) }}</span>
              </div>
              <div class="detailbox">
                <span class="label">次数</span><span>{{ info.specificationConfig.times }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import NkTable from '@/components/common/NkTable.vue'
import api from '../../../../../common/api'
export default {
  components: { NkTable },
  data () {
    return {
      companyId: 0,
      search: {
        date: [],
        status: -1
      },
      statusList: [
        { label: '计划中', value: 1 },
        { label: '已过期', value: 2 },
        { label: '已取消', value: 3 },
        { label: '执行中', value: 4 },
        { label: '已完成', value: 5 }
      ],
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      columns: [
        { prop: 'projectName', label: '项目名称', width: 200 },
        { prop: 'projectNumber', label: '项目编号', width: 160 },
        { prop: 'contractName', label: '合同名称' },
        { prop: 'contractNumber', label: '合同编号', width: 160 },
        { prop: 'serviceCompanyName', label: '服务公司' },
      ],
      tableData: [],
      page: {
        pageSizes: [10, 20, 30, 40], //每页显示条目个数
        size: 10,
        total: 0,
        pageIndex: 1,
      },
      drawer: false,
      info: null
    }
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    getData (pageIndex) {
      let vm = this
      const companyId = vm.companyId
      const { size } = vm.page
      const { status } = vm.search
      let startTime = null
      let endTime = null
      if (vm.search.date && vm.search.date.length === 2) {
        startTime = vm.search.date[0]
        endTime = vm.search.date[1]
      }
      api.electricOperations.listProjectVOInfoForClient(companyId, pageIndex, endTime, size, startTime, status).then(res => {
        let tableData = []
        if (res.success) {
          tableData = res.data.listData
          vm.page.pageIndex = res.data.currentPage
          vm.page.size = res.data.pageSize
          vm.page.total = res.data.totalCount
        }
        vm.tableData = tableData
      })
    },
    handleSizeChange (val) {
      this.size = val
      this.getData(1)
    },
    handleCurrentChange (val) {
      this.getData(val)
    },
    showInfo (row) {
      let vm = this
      vm.$api.electricOperations.getProjectVOListByProjectId(row.projectId).then(res => {
        if (res.success) {
          vm.drawer = true
          let info = res.data
          if (info.specificationConfig.length > 0) {
            info.specificationConfig = JSON.parse(info.specificationConfig)
          }
          info.contractName = row.contractName
          vm.info = info
        }
      })
    },
    getTask (cellValue) {
      let val = ''
      this.taskList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    getCycle (cellValue) {
      let val = ''
      this.cycleList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
  }
}
</script>

<style lang="scss" scoped>
.repository-warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  .repository-content {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;
    flex-flow: column;
    text-align: left;

    .search-warp {
      padding-bottom: 14px;
      display: flex;
      align-items: center;
    }
    .table-warp {
      flex: 1;
      overflow: hidden;
    }
    .form-container {
      padding: 0px 14px;
    }
  }
}

.drawer-main {
  color: #333;
  padding: 20px 30px 30px 30px;
  .drawer-header {
    display: flex;
    margin-bottom: 40px;
    .headbox {
      color: #999999;
      margin-right: 10px;
      .title {
        margin-right: 10px;
      }
      .satus {
        display: inline-block;
        padding: 8px;
        background: #f7eee9;
        border-radius: 4px;
        color: #fda32b;
      }
      .month {
        font-size: 24px;
        color: #333;
      }
    }
  }
  .drawer-cent {
    div {
      text-align: left;
    }
    .title {
      font-size: 18px;
    }
    .detailbox {
      margin-top: 15px;
      display: flex;
      .label {
        color: #999999;
        display: inline-block;
        width: 100px;
        text-align: right;
        margin-right: 12px;
      }
    }
  }
}
</style>
<style lang="scss">
.rows-content {
  .el-textarea__inner {
    min-height: 240px !important;
  }
}
</style>